import { convertCamelCaseToSnakeCase } from "@swa-ui/string";

import { isObject } from "../isObject";

/**
 * convertKeysFromCamelCaseToSnakeCase generates an object whose keys are transformed from camelCase to snake_case.
 * @param {object} objectWithCamelCaseKeys the object with keys in camelCase
 * @returns {object} the object with keys transformed from camelCase to snake_case
 */
export const convertKeysFromCamelCaseToSnakeCase = (object) => {
  const transformObject = (obj) => {
    let output;

    if (Array.isArray(obj)) {
      output = obj.map((item) => handleObjectAndArrays(item));
    } else {
      output = Object.keys(obj).reduce((acc, key) => {
        const camelKey = convertCamelCaseToSnakeCase(key);

        acc[camelKey] = handleObjectAndArrays(obj[key]);

        return acc;
      }, {});
    }

    return output;
  };

  function handleObjectAndArrays(item) {
    return isObject(item) || Array.isArray(item) ? transformObject(item) : item;
  }

  return isObject(object) ? transformObject(object) : object;
};
